export default __webpack_public_path__ + "media/9f55ff884c9a57269ec68994644b8c49257f70e2156b8ff373b5319dfc7b0fa6.svg";